import Login from './components/Login/Login';
import Logout from './components/Login/Logout';
import AccountView from './components/Order/AccountView';
import OrderView from './components/Order/OrderView';
import OrderThankYou from './components/Order/OrderThankYou';
import ProductsView from './components/Blocks/Products/View';
import ProductsEdit from './components/Blocks/Products/Edit';
import productsSVG from '@plone/volto/icons/images.svg';
import S3FileWidget from './components/Widgets/S3FileWidget';
import './components/Widgets/S3FileWidget.css';
import reducers from './reducers';

const applyConfig = (config) => {
  // Register reducers
  config.addonReducers = {
    ...config.addonReducers,
    ...reducers,
  };

  // Register S3 express middleware (only on server)
  if (__SERVER__) {
    const express = require('express');
    const s3Middleware = require('./express-middleware/s3').default;
    config.settings.expressMiddleware = [
      ...(config.settings.expressMiddleware || []),
      s3Middleware(express),
    ];
  }

  config.settings.supportedLanguages = ['ro'];
  config.settings.defaultLanguage = 'ro';

  // Products Block
  config.blocks.blocksConfig.productsBlock = {
    id: 'productsBlock',
    title: 'Produse interpretare',
    icon: productsSVG,
    group: 'media',
    view: ProductsView,
    edit: ProductsEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 0,
  };

  // Disable tags on View
  config.settings.showTags = false;

  // Enable Title block
  config.blocks.blocksConfig.title.restricted = false;

  // Enable description block (also for cypress)
  config.blocks.blocksConfig.description.restricted = false;
  config.blocks.requiredBlocks = [];

  // Date format for RO
  config.settings.dateLocale = 'ro';

  // GDPR - Google Analytics
  config.settings.DSGVOBanner = {
    ...config.settings.DSGVOBanner,
    trackingId: 'G-55QGYZ44ME',
    privacy_url: '/politica-si-confidentialitate',
  };

  // GDPR - Google Tag Manager
  config.settings.DSGVOBanner.tracker = {
    ...config.settings.DSGVOBanner.tracker,
    gtagOptions: {
      id: 'GTM-KQNXS4FX',
    }
  };

  config.views.contentTypesViews.account = AccountView;
  config.views.contentTypesViews.interpretare = OrderView;

  // Register S3 File Widget
  config.widgets.widget.s3file = S3FileWidget;

  // Login
  config.addonRoutes = [
    { path: '/login', component: Login },
    { path: '/**/login', component: Login },
    { path: '/logout', component: Logout },
    { path: '/**/logout', component: Logout },
    { path: '/register', component: Login },
    { path: '/thank-you', component: OrderThankYou },
    { path: '/**/thank-you', component: OrderThankYou },
    ...config.addonRoutes,
  ];

  return config;
};

export default applyConfig;
